import { useReducer } from "react";

import type { ICompetitors } from "app/pages/activation/components/Settings/Competitors/types";

import type { CompetitorsPayload } from "../../../modules/Settings/types";
import { CompetitorActions } from "../../../modules/Settings/types";

export const useCompetitorsActions = () => {
    const initialState = {
        mainCompetitors: [],
        competitors: [],
    } as ICompetitors;

    const reducerFn = (
        state: typeof initialState,
        {
            type,
            payload,
        }: {
            type: CompetitorActions;
            payload: CompetitorsPayload;
        },
    ) => {
        switch (type) {
            case CompetitorActions.set:
                return {
                    ...state,
                    [payload.assetKey]: payload.asset,
                };
            case CompetitorActions.add:
                return {
                    ...state,
                    [payload.assetKey]: [payload.selectedItem, ...state[payload.assetKey]],
                };
            case CompetitorActions.remove:
                return {
                    ...state,
                    [payload.assetKey]: [payload.selectedItem, ...state[payload.assetKey]],
                };
            case CompetitorActions.removeAll:
                return {
                    ...state,
                    mainCompetitors: payload.isMainCompetitorsActive
                        ? state.mainCompetitors.filter(({ name }) => name !== payload.selectedItem.name)
                        : [],
                    competitors: state.competitors.filter(({ name }) => name !== payload.selectedItem.name),
                };

            default:
                throw new Error();
        }
    };

    const [competitors, dispatchCompetitors] = useReducer(reducerFn, initialState);

    return { competitors, dispatchCompetitors };
};
